var map = {
	"./CAT_CHEMICAL_GAS.svg": "070a",
	"./CAT_CHEMICAL_MADE_RAWMATERIAL.svg": "74ef",
	"./CAT_CHEMICAL_MADE_REAGENT.svg": "725e",
	"./CAT_CHEMICAL_RAWMATERIAL.svg": "6380",
	"./CAT_CHEMICAL_REAGENT.svg": "55f4",
	"./CAT_CHEMICAL_STANDARD.svg": "a61d",
	"./CAT_CHROMATOGRAPHY.svg": "56d1",
	"./CAT_ETC.svg": "d2c9",
	"./CAT_LABWARE_EQUIPMENT.svg": "3ba3",
	"./CAT_LABWARE_TOOL.svg": "5bda",
	"./CAT_PROTECTION.svg": "37ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b73b";